import Vue from 'vue'
import App from './App.vue'
import router from '../router/index.js'
import store from '../store/index.js'

import 'amfe-flexible';
import 'ant-design-vue/dist/antd.css';
import '../assets/css/common.css';
import '../plugins/vant.js'
import '../plugins/ant.js'
import '../plugins/tsaui.js'
import '../assets/css/iconfont.css'

import '../utils/permission.js'
import less from 'less';
import {set, get } from '@/utils/localStorage';
import { hrefOpen } from '@/utils/filter'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VideoPlayer from 'vue-video-player'
import Clipboard from 'clipboard';
import TsaEnvironmentCheck from '@/plugins/EnvironmentCheck'
Vue.use(TsaEnvironmentCheck);
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(Viewer)
Vue.use(less);

Viewer.setDefaults({
    Options: {
        "inline": true,
        "button": true,
        "navbar": true,
        "title": true,
        "toolbar": true,
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": true,
        "keyboard": true,
        "url": "data-source"
    },
})

Vue.prototype.Clipboard = Clipboard;
Vue.config.productionTip = false;
Vue.prototype.$setlocalStorage = set;
Vue.prototype.$getlocalStorage = get;
Vue.prototype.$hrefOpen = hrefOpen;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')